import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1478 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1478 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M540.278545 1023.488009a67.710815 67.710815 0 0 1-56.959003-28.543501L28.5435 540.808456a81.15058 81.15058 0 0 1 0-123.389841 88.830445 88.830445 0 0 1 123.389841 0l388.345204 397.817038L1326.440787 28.56142a81.15058 81.15058 0 0 1 123.389841 0 81.15058 81.15058 0 0 1 0 123.389841L596.853555 1005.056332a80.254596 80.254596 0 0 1-56.57501 18.431677z\" fill=\"#80C269\" p-id=\"12288\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/right.svg
// module id = 9iyg
// module chunks = 40